import { ClientTranslations } from '@resources/client/ClientTranslations';
import { ClientTranslationKey } from '@resources/client/ClientTranslationKey';
let translations: Record<string, string> = {};
export function initialize(clientTranslations: ClientTranslations): void {
    translations = clientTranslations;
}
export function translate(
    translationKey: ClientTranslationKey,
    parameters?: Record<string, string | number>
): string {
    if (!(translationKey in translations)) {
        return translationKey;
    }
    let text = translations[translationKey];
    if (parameters) {
        text = text.replace(/{{\s*([^}\s]+)\s*}}/g, (_match, key) =>
            parameters[key] === undefined ? '' : parameters[key].toString()
        );
    }
    return text;
}
